export default "__VITE_ASSET__CwDX$ePF__"